// SCRM 模块 - 客户关系管理
import { VIP_URL, NAT_VIP_URL, SCRM_VIP_URL } from "@/api/config";

const state = {
    brandName: '25007',
    token: '',
    urlMap: {
        'beautyfarm': VIP_URL,
        'natrurade': NAT_VIP_URL,
        '25001': SCRM_VIP_URL, // 美田
        '25002': SCRM_VIP_URL,
        '25003': SCRM_VIP_URL,
        '25004': SCRM_VIP_URL,
        '25005': SCRM_VIP_URL, // 奈瑞儿
        '25006': SCRM_VIP_URL,
        '25007': SCRM_VIP_URL, // 思妍丽 整合
        '25008': SCRM_VIP_URL, 
    }
}

const getters = {
}

const mutations = {
    SET_BRAND_NAME(state, brandName) {
        state.brandName = brandName || '25007'
    },
    SET_TOKEN(state, token) {
        console.log('SET_TOKEN', token)
        state.token = token || ''
    }
}

const actions = {
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/scrm.js